export default __webpack_public_path__ + "static/media/nf.f115f4ab.svg";